
import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileUpload } from '@ascschool/share/file-upload/file-upload';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators'; 
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class AnnounceAttachmentService { 
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };    
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/TbaAnnounce';
    //upload declaration
    private _files: FileUpload[] = [];
    private _uploadQueue: BehaviorSubject<FileUpload[]>;
    private _isUploading: boolean;
    private _currentlyUploading: BehaviorSubject<boolean>;
    private _done: BehaviorSubject<any>;
    public done: Observable<any>;
    constructor(private http: HttpClient) {
        this._isUploading = false;
        this._currentlyUploading = new BehaviorSubject(this._isUploading);
        this._uploadQueue = new BehaviorSubject([]);
        this._done = new BehaviorSubject(null);
        this.done = this._done.asObservable();
    }
    clear(){
        this._done.next(null);
    }
    //Upload

    public addFileToQueue(file: File) {
        const queuedUploadFile = new FileUpload(file);
        this._files.push(queuedUploadFile);

        this._uploadQueue.next(this._files);

        this.checkAndUploadNextFile();
    }
    private checkAndUploadNextFile() {
        if (this._isUploading)
            return;

        let firstChoice = this._files.find(f => f.isWaitingForUpload);
        if (firstChoice)
            this.upload(firstChoice);
    }
    private upload(queuedUploadFile: FileUpload) {
        this.isUploading = true;
        queuedUploadFile.updateProgress(0);

        const request = this.createRequest(queuedUploadFile);
        this.http.request(request)
            .pipe(
                finalize(() => {
                    this.isUploading = false;
                    this.checkAndUploadNextFile();
                })
            )
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round(100 * event.loaded / event.total);
                    queuedUploadFile.updateProgress(percentDone);
                } else if (event instanceof HttpResponse) {
                    queuedUploadFile.completed();
                    this._done.next(event.body)
                }

                this._uploadQueue.next(this._files);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    queuedUploadFile.failed();
                } else {
                    // The backend returned an unsuccessful response code.
                    queuedUploadFile.failed();
                }

                this._uploadQueue.next(this._files);
            }, () => {

            });
    }
    
    private set isUploading(value: boolean) {
        this._isUploading = value;
        this._currentlyUploading.next(value);
    }
    private createRequest(queuedUploadFile: FileUpload) {
        const formData = new FormData();
        formData.append('files', queuedUploadFile.file, queuedUploadFile.file.name);
        const request = new HttpRequest('POST', this.url + '/Upload', formData, {
            reportProgress: true
        });
        return request;
    }
    public discardUploadFile(id : any){ 
        return this.http.delete(`${this.url}/DeleteById/${id}`, this.httpOptions);
    }
}